<template>
  <Button
    :class="['w-full transition-colors duration-300', copied && '!bg-success']"
    variant="primary-flat"
    bg-hover-color="transparent"
    @click="copy(link)"
  >
    <Transition name="fade" mode="out-in">
      <span v-if="copied" class="inline-flex items-center gap-2"
        ><IconsCheckmark class="h-4 w-4" />Copied!</span
      >
      <span v-else class="inline-flex items-center gap-2"
        ><IconsCopy class="h-4 w-4" />Copy referral link</span
      >
    </Transition>
  </Button>
</template>

<script setup lang="ts">
const props = defineProps<{ referralCode: string }>();

const { copied, copy } = useClipboard();
const config = useRuntimeConfig();
const link = computed(() =>
  config.public.referralLinkUrlTemplate.replace("{code}", props.referralCode),
);
</script>
